import React from 'react';
import Svg from '../../../../sharedComponents/SvgImage/Svg';
import { BASE_IMAGE_URL } from '../../../../configs/constants';
import { CaretRight } from '../../../../sharedComponents/Icons';
import { checkColor } from '@app/utils';
import { ThemedPressable, ThemedView, ThemedText } from '@app/theme';
import ROUTE from '@app/navigationApp/routes';

const InterestCalculatorCard = ({navigation}) => {

  const handleOnPress = () => {
    navigation.navigate(ROUTE.INTEREST_CALCULATOR);
  };

  return (
    <ThemedPressable
      flexDirection='row'
      px='xl'
      py='sm'
      bg='bg-fill-primary'
      borderRadius='md'
      borderWidth={1}
      borderColor='border-primary'
      marginHorizontal='lg'
      onPress={handleOnPress}>
      <ThemedView 
        alignItems='center'
        justifyContent='center'>
        <Svg
          url={BASE_IMAGE_URL + 'icn-calculator.svg'}
          height={40}
          width={40}
        />
      </ThemedView>
      <ThemedView 
        flex={1}
        ml="md"
        >
          <ThemedText variant='b3m' color='text-primary'>
            Interest Calculator
          </ThemedText>
          <ThemedView style={{height: 2}}/>
          <ThemedText variant='b4r' color='text-secondary'>
            Calculate EMI on loan against MF
          </ThemedText>
          <ThemedView style={{height: 2}}/>
          <ThemedText variant='b4b' color='text-action-primary'>
            Check now
          </ThemedText>
      </ThemedView>
      <ThemedView
        alignItems='center'
        justifyContent='center'>
        <CaretRight height={14} width={14} color={checkColor('#1434CB')} />
      </ThemedView>
    </ThemedPressable>
  );
};
export default InterestCalculatorCard;
